<template>
  <analytics-sub-page
    title="Education Analytics"
    icon="graduation-cap"
    css-class="analytics-education"
    default-label="Education"
    :section-specs="sectionSpecs"
  >
    <coach-metrics ref="coachRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import CoachMetrics, { coachMetricsSections } from '@/pages/analyticsApp/components/CoachMetrics.vue';

const coachRef = ref(null);

// CoachMetrics carves itself into four logical subsections (Coach / Education /
// Benefits Checker / Debt Advice). The section descriptors live with the
// component so this tab and the homepage "Download all" capture stay in sync.
const sectionSpecs = coachMetricsSections(coachRef);
</script>
